import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        modifyTypeId: null, // 变更类型
        modifyMark: null, // 变更内容
        modifyDate: null // 变更批准时间
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "select",
          label: "变更类型：",
          value: "modifyTypeId",
          placeholder: "请选择",
          clearable: true,
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131608570016"
          }
        },
        {
          type: "input",
          label: "变更内容：",
          value: "modifyMark",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "date",
          label: "变更批准时间：",
          value: "modifyDate",
          valueFormat: "yyyy-MM-dd",
          clearable: true
        }
      ],
      // 国家或地区表格基础数据
      tableColumns: [
        {
          label: "变更类型",
          prop: "modifyTypeName",
          isShow: true
        },
        {
          label: "变更内容",
          prop: "modifyMark"
        },
        {
          label: "变更批准时间",
          prop: "modifyDate"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },

  // 接收父组件传递的数据
  props: {
    // 页面类型
    basicInfoId: {
      type: String
    }
  },

  // 模板编译完成
  mounted() { },

  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 发起请求
      fun_PostAction("/corpModifyDetailinfo/list", {
        ...this.form,
        ...this.reqPageData,
        basicInfoId: this.basicInfoId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 国家或地区表格数据
          this.tableData = data.records;
          // 国家或地区列表总条数
          this.total = data.total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e) {
      // 变更类型
      this.form.modifyTypeId = e;
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询事件
     * @author shuhua
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    }
  }
};
